import { useTranslation } from "react-i18next";
import { CatHeading } from "@cat-digital-blocks/react/bedrock/components/Heading";
import { CatTextPassage } from "@cat-digital-blocks/react/bedrock/components/TextPassage";
import styles from "./Home.module.scss";

/**
 * Home Page Component
 */
const Home = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.homePage}>
      <div>
        <CatHeading level="h2">{t("home.welcome")}</CatHeading>
        <CatTextPassage>
          <p>{t("home.selectWorkflow")}</p>
        </CatTextPassage>
      </div>
    </div>
  );
};

Home.displayName = "Home";

export default Home;
